import { Card } from '@material-tailwind/react'
import React from 'react'
import { useShared } from '../../hooks/useShared'
export default function NotAllowed() {

    const { navigate } = useShared()
    return (
        <Card className='p-5' style={{direction:'ltr'}}>
            <p> <span className='text-red-900'>Access Denied:</span>  Sorry, you do not have authorization to view this page.</p>
            <p className='text-blue-400 underline text-center cursor-pointer' onClick={() => navigate("/db/dashboard")}>Go to Dashboard</p>
        </Card>
    )
}
